import { get, post } from './httpClient'

// Trung tâm thông báo (plan 261023-2005 phase 02) — BE luôn lọc theo user đăng nhập.
export const getNotifications = (params) => get('/notifications', params)
export const getUnreadCount = () => get('/notifications/unread-count')
export const markNotificationsRead = (ids) => post('/notifications/read', { ids })
export const markAllNotificationsRead = (filter) => post('/notifications/read-all', filter || {})
